import React, { useEffect, useState } from "react";
import { Sparkles, ChevronRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";

export default function LinaCard() {
  const { t, lang } = useI18n();
  const [data, setData] = useState({ greeting: "", tips: [], weekly_delta: 0 });

  useEffect(() => {
    api.get(`/lina/today`, { params: { lang } })
      .then((r) => setData(r.data))
      .catch(() => {});
  }, [lang]);

  return (
    <div data-testid="lina-card" className="ag-card p-7 relative overflow-hidden">
      <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-amber-100/60 blur-3xl pointer-events-none" />
      <div className="relative">
        <div className="flex items-center gap-2 mb-4">
          <div className="h-8 w-8 rounded-full bg-gradient-to-br from-amber-300 to-amber-500 flex items-center justify-center text-white shadow-sm ag-pulse-gold">
            <Sparkles className="h-4 w-4" />
          </div>
          <div>
            <div className="font-serif text-lg leading-none text-ag-ink">{t.lina.title}</div>
            <div className="text-[11px] text-slate-500 mt-0.5">{t.lina.sub}</div>
          </div>
        </div>

        <div className="font-serif text-2xl md:text-[26px] leading-snug text-ag-ink mb-4">
          {data.greeting}
        </div>

        <ul className="space-y-3">
          {data.tips?.map((tip, idx) => (
            <li key={idx} className="flex items-start gap-3 text-sm text-slate-700">
              <ChevronRight className="h-4 w-4 mt-0.5 text-amber-500 shrink-0" strokeWidth={2} />
              <span>{tip}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
